import type {
  MeasurementField,
  MeasurementFieldCreate,
} from "@/types/measurement";

import { requestData } from "@/api/api-config";

export async function listMeasurementFields(): Promise<
  MeasurementField[] | null
> {
  return await requestData<MeasurementField[]>(
    "admin/measurement-fields",
    "get",
  );
}

export async function createMeasurementField(
  data: MeasurementFieldCreate,
): Promise<MeasurementField | null> {
  return await requestData<MeasurementField>(
    "admin/measurement-fields",
    "post",
    {
      json: data,
    },
  );
}

export async function updateMeasurementField(
  fieldId: string,
  data: Partial<MeasurementFieldCreate>,
): Promise<MeasurementField | null> {
  return await requestData<MeasurementField>(
    `admin/measurement-fields/${fieldId}`,
    "put",
    { json: data },
  );
}

export async function archiveMeasurementField(fieldId: string): Promise<void> {
  await requestData(`admin/measurement-fields/${fieldId}`, "delete");
}
